import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, strokeWidth, typography } = themeVariables;

export const section = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(${spacing.lg});
  padding: var(${spacing.xl}) var(${spacing.lg});
  text-align: center;
`;

export const introText = css`
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.brand});
`;

/* Pixel caps below (logo/illustration heights, card minimum width) are
   one-off dimensions, not theme tokens; values tuned against the Figma design
   (file 9xp6T9Dx6k8mU9NWfZEs7d, node 3540:31381, DISC-2797). */
export const logo = css`
  max-height: 89px;
  max-width: 100%;
  object-fit: contain;
`;

export const headline = css`
  margin: 0;
  max-width: 40ch;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.md.fontSize});
  line-height: var(${typography.heading.sizes.md.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.brand});
`;

export const cardList = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(${spacing.lg});
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const card = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: var(${spacing.md});
  padding: var(${spacing.md});
  border: var(${strokeWidth}) solid var(${colors.stroke.default});
  background: var(${colors.surface.default});
`;

export const cardImage = css`
  height: 130px;
  max-width: 100%;
  object-fit: contain;
`;

export const cardText = css`
  margin: 0;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.xs.fontSize});
  line-height: var(${typography.heading.sizes.xs.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.default});
`;
